import { Component, OnInit } from '@angular/core';
import { ShowhideService } from '../../../services/showhide/showhide.service';


@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {
    isPlaylistOpen:boolean;

  constructor(
      private nav: ShowhideService,
  ) {
      this.nav.openPlaylistEmitter().subscribe((new_click => {
          this.isPlaylistOpen = new_click
      }))
   }

  ngOnInit() {
  }

}
